import { H2, Main, Section } from "../Styles/Global.Styled";
import { useLocation } from "react-router-dom";
import { css } from "styled-components";
import { useEffect, useState } from "react";
import { getStoreProducts } from "../api/product";
import Carousel from "../Components/Carousel/Carousel";
import ProductAd from "../Components/Product/ProductAd";
import ProductPage from "../Components/Product/ProductPage";
import NavBackButton from "../Components/Buttons/NavBackButton";
import { sizes } from "../Styles/theme";

const sectionStyle = css`
  padding: 10vh 7vw;
  gap: 3vh;
    @media (max-width: ${sizes.tablet}) {
      padding: 5vh 7vw 10vh;
    }
`;

const Product = () => {
  const { state } = useLocation();
  // const { productCode } = useParams();
  const [product] = useState(state?.product || null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProduct = async () => {
      const res = await getStoreProducts();
      setProducts(res);
      console.log("res", res);
    };
    fetchProduct();
  }, []);

  return (
    <Main>
      <NavBackButton />
      <ProductPage product={product} />
      <Section $baseStyle={sectionStyle}>
        <H2>You might also like</H2>
        <Carousel
          items={products.filter(({ _id }) => product._id !== _id) || []}
          Component={ProductAd}
        />
      </Section>
    </Main>
  );
};

export default Product;